import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { webSocket } from "rxjs/webSocket";
// import { environment } from '../../environments/environment';
// import { LexRuntime, CognitoIdentityCredentials } from 'aws-sdk';

// import { lexParams } from '../lexParams';
// import { lexInput } from '../lexInput';

import { Observable, BehaviorSubject, Subject } from "rxjs";
// import { BehaviorSubject } from 'rxjs/BehaviorSubject';

export class Message {
  constructor(
    public content: string,
    public sentBy: string,
    public timestamp: number,
    public resCard: any,
    public slotToElicit: string,
    public imageData: string,
    public showForm: boolean,
    public table?: Object,
    public imageDescription?: Object,
    public showImage?: boolean
  ) {}
}

@Injectable({
  providedIn: "root",
})
export class ChatService {
  private typingIndicator = new Subject<any>();
  // readonly lexClient = new LexRuntime({
  //   region: environment.lex.region,
  //   accessKeyId: environment.lex.accessKeyId,
  //   secretAccessKey: environment.lex.secretAccessKey
  // });

  public msg: Message;
  public multilineMsg: string = "";
  public subject;
  public reqTime;
  userDetails = {};
  conversation = new BehaviorSubject<Message[]>([]);
  public apiUrl =
    "https://2e84e4s305.execute-api.us-east-2.amazonaws.com/prod/chatbot/web-view";

  chatbots = [
    {
      Id: "b3aae410-7ad4-11ed-b55b-ff7587788b4f",
      language: "en",
    },
    {
      Id: "07ba0920-7ae7-11ed-aec0-939fa968c27c",
      language: "es",
    },
  ];

  public chatbotId: string = "b3aae410-7ad4-11ed-b55b-ff7587788b4f";

  constructor(private http: HttpClient) {}

  update(msg: Message) {
    this.conversation.next([msg]);
  }

  typingIndicatorFn(): Observable<any> {
    return this.typingIndicator.asObservable();
  }

  callwebApi(body: any): Observable<any> {
    const apiUrl = this.apiUrl;
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    console.log(
      "data from api",
      this.http.post<any>(apiUrl, body, httpOptions)
    );
    return this.http.post<any>(apiUrl, body, httpOptions);
  }

  callsavefile(body: any): Observable<any> {
    const apiUrl =
      "https://obwruxueyb.execute-api.eu-west-1.amazonaws.com/Foundry-chatbot/save";
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http.post<any>(apiUrl, body, httpOptions);
  }

  converse(
    msg: any,
    sessionId: any,
    sessionState: any,
    userInfo: any,
    sessionDetails: any,
    seesionAtribb: any,
    slotToElicit: any,
    image: any,
    showMsg: any,
    msg_text?:string
  ): Promise<any> {
    // console.log('seesionAtribb: ', seesionAtribb);
    // console.log('sessionDetails: ', sessionDetails);
    this.typingIndicator.next(true);
    let sendReply = true;
    return new Promise((resolve, reject) => {
      // console.log('-->',msg);
      if (showMsg) {
      } else {
        const userMsg = new Message(
          msg_text?msg_text:msg,
          "bot",
          new Date().getTime(),
          null,
          null,
          image,
          false
        );
        this.update(userMsg);
      }

      // console.log('-->', slotToElicit);
      // if (slotToElicit !== 'eventId' && slotToElicit !== 'deleteEventId') {
      //   this.update(userMsg);
      // }

      // if (seesionAtribb.itemList) {
      //   const propertyDetail = JSON.parse(seesionAtribb.itemList);
      //   // console.log('lowecase error',params.inputText);
      //   propertyDetail.forEach((element) => {
      //     if (element.jb_prop_code.toLowerCase() === msg.toLowerCase()) {
      //       seesionAtribb['selectedProp'] = element.jb_prop_code;
      //       if (seesionAtribb['language'] === 'Arabic') {
      //         msg = '???? ?';
      //       } else {
      //         msg = 'Interested in';
      //       }
      //     }
      //   });
      // }
      // console.log('lexMsg: ', lexMsg);
      let a = {
        message: msg.trim(),
        botId: "LDRNN97PND",
        botAliasId: "TSTALIASID",
        chatbotId: "b3aae410-7ad4-11ed-b55b-ff7587788b4f",
        sessionId: sessionId,
        chatbots: [
          {
            Id: "b3aae410-7ad4-11ed-b55b-ff7587788b4f",
            language: "en",
          },
          {
            Id: "07ba0920-7ae7-11ed-aec0-939fa968c27c",
            language: "es",
          },
        ],
      };

      if (sessionState) {
        a["sessionState"] = sessionState;
      }
      if (image) {
        a["messageFormate"] = "file";
        a["sessionAttributes"] = {
          inputText: "1",
          inputData: image,
        };
      } else {
        a["messageFormate"] = "plainText";
        a["sessionAttributes"] = {
          inputText: msg.trim(),
        };
      }
      if (userInfo) {
        a["userInfo"] = userInfo;
        this.userDetails = userInfo;
      }
      if (sessionDetails) {
        if (Object.keys(sessionDetails).length > 0) {
          a["sessionDetails"] = sessionDetails;
        }
      }
      // console.log('Req Time',this.reqTime);
      this.multilineMsg = this.multilineMsg + "" + msg;
      a["message"] = this.multilineMsg;
      if (sessionDetails) {
        if (
          sessionDetails["intentName"] == "imageOCR" &&
          sessionDetails.slotToElicit == "imageload"
        ) {
          // console.log('Pre ocr data ',sessionDetails);
          if (image) {
            sessionDetails.sessionAttributes.imageData = image;
            a["message"] = "abide";
          } else {
            // console.log('image not found');
          }
        }
        if (sessionDetails["intentName"] == "updateId" && image) {
          sendReply = false;
          // console.log('-->',image.substring(image.indexOf('/')+1,image.indexOf(';')));
          const body = {
            base64_data: image,
            filename:
              "profile." +
              image.substring(image.indexOf("/") + 1, image.indexOf(";")),
          };
          this.callsavefile(body).subscribe((data) => {
            // console.log('data', data);
            const userMessage = new Message(
              "Document has been uploaded successfully.",
              "user",
              new Date().getTime(),
              null,
              null,
              null,
              false
            );
            this.update(userMessage);

            // this.lastMsg = {
            //   timestamp: 1589366716,
            //   message: 'Document Uploaded',
            //   showForm: true
            // };
          });
        }
      }
      if (seesionAtribb) {
        a["sessionState"]["sessionAttributes"] = seesionAtribb;
      }

      // console.log('What is my message ',a['message']);
      if (sendReply) {
        this.callwebApi(a).subscribe(
          (data) => {
            console.log("response 218", data);
            if (data.message) {
              const removableIndexes = [];
              let messages = data.message;
              // messages.forEach((msg, index) => {
              //   console.log("dataaaa",msg);
              //   if (msg.indexOf('<button>') !== -1) {
              //     msg = msg.replace('<button>', '');
              //     const content = JSON.parse(msg);
              //     messages.splice(index, 1);
              //     messages = messages.concat(content);
              //   }
              // });
              // const content = JSON.parse(messages);
              //  messages.splice(index, 1);
              messages = messages.concat(data.message);
              //  data.message = messages;
              this.typingIndicator.next(false);
              // if (!data["sessionDetails"] || true) {
              //(data['chatbotId'] == 'lexKendraIntegration' && true)
              //  if(data["sessionDetails"]){
              //    data.message= data.messages
              //  }
              this.multilineMsg = "";

              // console.log('show form->',data);

              if (msg == "test") {
                // console.log('Test is called');
              }
              if (data.chatUrl) {
                // console.log('url ',data.chatUrl);
                this.createWebSocketConn(data);
              }
              if (data.closeConnection) {
                this.disconnectConn();
              }

              let t = 0;
              console.log(data);

              if (data.hasOwnProperty("messages")) {
                let t = 0;
                console.log("data >>", data);
                var speech = "";

                console.log("hhhh 291", data.messages);
                data.messages.forEach((message) => {
                  if (message.contentType == "PlainText") {
                    // data.message = message.content.replace(/\*/g, function (match) {
                    //   t++;
                    //   return t % 2 == 0
                    //     ? "</span>"
                    //     : "<span class='boldMsg' style='font-weight: bold important!;'>";
                    // });
                    // data.message = message.content.replace("Hello", "<br/> Hello");

                    let item = message.content.replace(/\\n/gi, "<br />");
                    console.log("item", item);
                    // let checkItem = items;
                    // checkItem.forEach((item,index)=>{
                    //   if(item.length <= 2){
                    //     items.splice(index,1);
                    //   }
                    // });
                    // items.forEach((item, index) => {
                    // if(item.length > 0){
                    // console.log('index-->',item.length,index);
                    if (data.sessionDetails) {
                      data.slotToElicit = data.sessionDetails.slotToElicit;
                    }
                    const userMessage = new Message(
                      item,
                      "user",
                      new Date().getTime(),
                      data.responseCard ? data.responseCard : null,
                      data.slotToElicit ? data.slotToElicit : null,
                      null,
                      false
                    );
                    this.update(userMessage);

                    // }
                    // });
                  } else if (
                    message.contentType == "ImageResponseCard" ||
                    (message.contentType == "CustomPayload" &&
                      message.content.includes("<button>"))
                  ) {
                    var content = "";
                    console.log("here 511", message);
                    if (
                      message.contentType == "CustomPayload" ||
                      message.contentType == "ImageResponseCard"
                    ) {
                      message["imageResponseCard"] = message.content.replace(
                        /<button>/gi,
                        ""
                      );
                      message["imageResponseCard"] = JSON.parse(
                        message["imageResponseCard"].trim()
                      );
                      message["imageResponseCard"] = JSON.parse(
                        message["imageResponseCard"].trim()
                      );
                      message.contentType = "ImageResponseCard";
                      console.log("message 517", message);
                      delete message.content;
                    }
                    // if(message.imageResponseCard.title.includes("Is there anything else I can help you with?")){
                    //   content = "NBI"
                    //   const NBIMessage = new Message(
                    //     message.imageResponseCard.title,
                    //     "user",
                    //     new Date().getTime(),
                    //     null,
                    //     null,
                    //     null,
                    //     false
                    //   );
                    //   this.update(NBIMessage);
                    // }
                    if (message.imageResponseCard.hasOwnProperty("title")) {
                      message.imageResponseCard.title =
                        message.imageResponseCard.title.replace(
                          /\\n/gi,
                          "<br />"
                        );
                    }
                    if (message.imageResponseCard.hasOwnProperty("subtitle")) {
                      message.imageResponseCard.subtitle =
                        message.imageResponseCard.subtitle.replace(
                          /\\n/gi,
                          "<br />"
                        );
                    }
                    const userMessage = new Message(
                      content,
                      "user",
                      new Date().getTime(),
                      message.contentType == "ImageResponseCard"
                        ? { genericAttachments: [message.imageResponseCard] }
                        : null,
                      data.slotToElicit ? data.slotToElicit : null,
                      null,
                      false
                    );
                    console.log("message after update", userMessage);
                    this.update(userMessage);
                  } else if (message.contentType == "SSML") {
                    this.createWebSocketConn(message);
                  } else if (message.contentType == "CustomPayload") {
                    var content = "";
                    if (message.content.includes("<table>")) {
                      message.content = message.content.replace(
                        /<table>/gi,
                        ""
                      );
                      content = "table";
                      var table = JSON.parse(message.content);
                    } else if (message.content.includes("<image>")) {
                      message.content = message.content.replace(
                        /<image>/gi,
                        ""
                      );
                      content = "image";
                    }
                    const userMessage = new Message(
                      content,
                      "user",
                      new Date().getTime(),
                      null,
                      null,
                      null,
                      false,
                      content == "table"
                        ? JSON.parse(message.content)
                        : undefined,
                      content == "image"
                        ? JSON.parse(message.content)
                        : undefined
                    );
                    this.update(userMessage);
                  }
                });
              } else if (data.hasOwnProperty("message")) {
                const userMessage = new Message(
                  data.message,
                  "user",
                  new Date().getTime(),
                  data.responseCard ? data.responseCard : null,
                  data.slotToElicit ? data.slotToElicit : null,
                  null,
                  false
                );
                this.update(userMessage);
              } else {
                const userMessage = new Message(
                  "can you please repeat that?",
                  "user",
                  new Date().getTime(),
                  data.responseCard ? data.responseCard : null,
                  data.slotToElicit ? data.slotToElicit : null,
                  null,
                  false
                );
                this.update(userMessage);
              }
              resolve(data);

              if (data["sessionDetails"]) {
                if (
                  data["sessionDetails"].intentName == "supportTicket" &&
                  data["sessionDetails"].slotToElicit == "ticket"
                ) {
                  const userMessage = new Message(
                    "form",
                    "form",
                    new Date().getTime(),
                    data.responseCard ? data.responseCard : null,
                    data.slotToElicit ? data.slotToElicit : null,
                    null,
                    true
                  );
                  this.update(userMessage);
                }
              }
            }

            // }
            else {
              console.log("hhhh", data);
              const removableIndexes = [];
              let messages = [...data.messages];
              // data.messages.forEach((msg, index) => {
              // if (msg.content.indexOf('<button>') !== -1) {
              //  msg.content = msg.content.replace('<button>', '');
              // const content = JSON.parse(msg.content);
              // messages.splice(index, 1);
              // messages = messages.concat(content);
              // }
              // });
              data.messages = [...messages];
              this.typingIndicator.next(false);
              if (!data["sessionDetails"] || true) {
                //(data['chatbotId'] == 'lexKendraIntegration' && true)
                this.multilineMsg = "";

                // console.log('show form->',data);

                if (msg == "test") {
                  // console.log('Test is called');
                }
                if (data.chatUrl) {
                  // console.log('url ',data.chatUrl);
                  this.createWebSocketConn(data);
                }
                if (data.closeConnection) {
                  this.disconnectConn();
                }

                let t = 0;
                console.log(data);

                if (data.hasOwnProperty("messages")) {
                  let t = 0;
                  console.log("data >>", data);
                  var speech = "";
                  // if (data.messages[0].contentType == "PlainText") {
                  //     data.message = data.messages[0].content.replace(/\*/g, function (match) {
                  //     t++;
                  //     return t % 2 == 0
                  //       ? "</span>"
                  //       : "<span class='boldMsg' style='font-weight: bold important!;'>";
                  //   });
                  //   data.message = data.messages[0].content.replace("Hello", "<br/> Hello");
                  //   speech = data.messages[0].content;
                  // }

                  data.messages.forEach((message) => {
                    console.log("469");
                    if (message.contentType == "PlainText") {
                      // data.message = message.content.replace(/\*/g, function (match) {
                      //   t++;
                      //   return t % 2 == 0
                      //     ? "</span>"
                      //     : "<span class='boldMsg' style='font-weight: bold important!;'>";
                      // });
                      // data.message = message.content.replace("Hello", "<br/> Hello");
                      message.content = message.content.replaceAll(/\*/g, function (match) {
                        t++;
                        return t % 2 == 0
                          ? "</span>"
                          : "<span class='boldMsg' style='font-weight: bold important!;'>";
                      });
                      if (message.content.includes("#@#")){

                        let values = message.content.split("#@#");
                   values.forEach((ele, index) => {
                     if (ele.startsWith("http")) {
                     console.log("values ele ",ele);
                     
                       values[index] =
                         '<a href="' + ele + '" target="_blank"> link here ' + "</a>";
                     }
                   });
                   values = values.join("#@#");
                   message.content = values.replaceAll("#@#","");
                      }
  
                   else if (message.content.includes("#@@")){

                        let values = message.content.split("#@@");
                   values.forEach((ele, index) => {
                     if (ele.includes("@")) {
                     console.log("values ele ",ele);
                     
                       values[index] =
                         '<a href="mailto:'+ ele +'"> E-mail' + "</a>";
                     }
                   });
                   values = values.join("#@@");
                   message.content = values.replaceAll("#@@","");
                      }
                  // data.message = data.message.replace(/\n/g, "<br/>");
                  // const speech = data.message;
                      console.log("data msg bold",message)
                      let item = message.content.replace(/\\n/gi, "<br />");
                      console.log("item", item);
                      // let checkItem = items;
                      // let checkItem = items;
                      // checkItem.forEach((item,index)=>{
                      //   if(item.length <= 2){
                      //     items.splice(index,1);
                      //   }
                      // });
                      // items.forEach((item, index) => {
                      // if(item.length > 0){
                      // console.log('index-->',item.length,index);
                      if (data.sessionDetails) {
                        data.slotToElicit = data.sessionDetails.slotToElicit;
                      }
                      const userMessage = new Message(
                        item,
                        "user",
                        new Date().getTime(),
                        data.responseCard ? data.responseCard : null,
                        data.slotToElicit ? data.slotToElicit : null,
                        null,
                        false
                      );
                      this.update(userMessage);

                      // }
                      // });
                    } else if (
                      message.contentType == "CustomPayload" &&
                      message.content.includes("<button>")
                    ) {
                      var content = "";
                      console.log("here 511", message);
                      if (
                        message.contentType == "CustomPayload" ||
                        message.contentType == "ImageResponseCard"
                      ) {
                        message["imageResponseCard"] = message.content.replace(
                          /<button>/gi,
                          ""
                        );
                        message["imageResponseCard"] = JSON.parse(
                          message["imageResponseCard"].trim()
                        );
                        message["imageResponseCard"] = JSON.parse(
                          message["imageResponseCard"].trim()
                        );
                        message.contentType = "ImageResponseCard";
                        console.log("message 517", message);
                        delete message.content;
                      }

                      if (message.imageResponseCard.hasOwnProperty("title")) {
                        message.imageResponseCard.title =
                          message.imageResponseCard.title.replace(
                            /\\n/gi,
                            "<br />"
                          );
                      }
                      if (
                        message.imageResponseCard.hasOwnProperty("subtitle")
                      ) {
                        message.imageResponseCard.subtitle =
                          message.imageResponseCard.subtitle.replace(
                            /\\n/gi,
                            "<br />"
                          );
                      }
                      const userMessage = new Message(
                        content,
                        "user",
                        new Date().getTime(),
                        message.contentType == "ImageResponseCard"
                          ? { genericAttachments: [message.imageResponseCard] }
                          : null,
                        data.slotToElicit ? data.slotToElicit : null,
                        null,
                        false
                      );
                      console.log("message after update", userMessage);
                      this.update(userMessage);
                    } else if (message.contentType == "ImageResponseCard") {
                      if (message.imageResponseCard.hasOwnProperty("title")) {
                        message.imageResponseCard.title =
                          message.imageResponseCard.title.replace(
                            /\\n/gi,
                            "<br />"
                          );
                      }
                      if (
                        message.imageResponseCard.hasOwnProperty("subtitle")
                      ) {
                        message.imageResponseCard.subtitle =
                          message.imageResponseCard.subtitle.replace(
                            /\\n/gi,
                            "<br />"
                          );
                      }
                      const userMessage = new Message(
                        "",
                        "user",
                        new Date().getTime(),
                        message.contentType == "ImageResponseCard"
                          ? { genericAttachments: [message.imageResponseCard] }
                          : null,
                        data.slotToElicit ? data.slotToElicit : null,
                        null,
                        false
                      );
                      this.update(userMessage);
                    } else if (message.contentType == "CustomPayload") {
                      var content = "";
                      if (message.content.includes("<table>")) {
                        message.content = message.content.replace(
                          /<table>/gi,
                          ""
                        );
                        content = "table";
                        var table = JSON.parse(message.content);
                      } else if (message.content.includes("<image>")) {
                        message.content = message.content.replace(
                          /<image>/gi,
                          ""
                        );
                        content = "image";
                      }
                      const userMessage = new Message(
                        content,
                        "user",
                        new Date().getTime(),
                        null,
                        null,
                        null,
                        false,
                        content == "table"
                          ? JSON.parse(message.content)
                          : undefined,
                        content == "image"
                          ? JSON.parse(message.content)
                          : undefined
                      );
                      this.update(userMessage);
                    } else if (message.contentType == "SSML") {
                      this.createWebSocketConn(message);
                    }
                  });
                } else if (data.hasOwnProperty("message")) {
                  const userMessage = new Message(
                    data.message,
                    "user",
                    new Date().getTime(),
                    data.responseCard ? data.responseCard : null,
                    data.slotToElicit ? data.slotToElicit : null,
                    null,
                    false
                  );
                  this.update(userMessage);
                } else {
                  const userMessage = new Message(
                    "can you please repeat that?",
                    "user",
                    new Date().getTime(),
                    data.responseCard ? data.responseCard : null,
                    data.slotToElicit ? data.slotToElicit : null,
                    null,
                    false
                  );
                  this.update(userMessage);
                }
                resolve(data);

                if (data["sessionDetails"]) {
                  if (
                    data["sessionDetails"].intentName == "supportTicket" &&
                    data["sessionDetails"].slotToElicit == "ticket"
                  ) {
                    const userMessage = new Message(
                      "form",
                      "form",
                      new Date().getTime(),
                      data.responseCard ? data.responseCard : null,
                      data.slotToElicit ? data.slotToElicit : null,
                      null,
                      true
                    );
                    this.update(userMessage);
                  }
                }
              }
            }
          },
          (err) => {
            console.log("err", err);
          }
        );
      }
    });
  }

  createWebSocketConn(data: any) {
    console.log("data");
    this.subject = webSocket(data.content);
    this.subject.subscribe(
      (msgRes) => {
        //console.log('message received: ' + JSON.stringify(msgRes));
        if (typeof msgRes.content == "string") {
          const messageContent = JSON.parse(msgRes.content);
          if (
            messageContent.ContentType ==
            "application/vnd.amazonaws.connect.event.participant.left"
          ) {
            const userMessage1 = new Message(
              "Agent left the conversation.",
              "user",
              new Date().getTime(),
              data.responseCard ? data.responseCard : null,
              data.slotToElicit ? data.slotToElicit : null,
              null,
              false
            );
            this.update(userMessage1);
            this.disconnectConn();
            this.closeAgentConnection().subscribe((data) => {
              const userMessage1 = new Message(
                data.message,
                "user",
                new Date().getTime(),
                data.responseCard ? data.responseCard : null,
                data.slotToElicit ? data.slotToElicit : null,
                null,
                false
              );
              this.update(userMessage1);
            });
          }
          if (
            messageContent.ContentType ==
              "application/vnd.amazonaws.connect.event.participant.joined" &&
            messageContent.ParticipantRole == "AGENT"
          ) {
            const userMessage1 = new Message(
              "Agent joined the conversation.",
              "user",
              new Date().getTime(),
              data.responseCard ? data.responseCard : null,
              data.slotToElicit ? data.slotToElicit : null,
              null,
              false
            );
            this.update(userMessage1);
          }
          if (messageContent.Content == "Something went wrong. Goodbye.") {
            const userMessage1 = new Message(
              "No Agent is active for now. Please contact later. Closing the connection.",
              "user",
              new Date().getTime(),
              data.responseCard ? data.responseCard : null,
              data.slotToElicit ? data.slotToElicit : null,
              null,
              false
            );
            this.update(userMessage1);
            this.disconnectConn();
            this.closeAgentConnection().subscribe((data) => {
              const userMessage1 = new Message(
                data.message,
                "user",
                new Date().getTime(),
                data.responseCard ? data.responseCard : null,
                data.slotToElicit ? data.slotToElicit : null,
                null,
                false
              );
              this.update(userMessage1);
            });
          }
          if (
            messageContent.ParticipantRole == "AGENT" &&
            messageContent.Content
          ) {
            const speech1 = messageContent.Content.toString();
            const userMessage1 = new Message(
              speech1,
              "user",
              new Date().getTime(),
              data.responseCard ? data.responseCard : null,
              data.slotToElicit ? data.slotToElicit : null,
              null,
              false
            );
            this.update(userMessage1);
          }
        }
      },
      (err) => console.log(err),
      () => console.log("complete")
    );
    // webSocke
    this.subject.next({
      topic: "aws/subscribe",
      content: { topics: ["aws/chat"] },
    });
  }

  disconnectConn() {
    this.subject.complete();
  }

  closeAgentConnection(): Observable<any> {
    let endConn = {
      message: "stop agent",
      chatbotId: this.chatbotId,
      userInfo: this.userDetails,
    };
    const apiUrl = this.apiUrl;
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.http.post<any>(apiUrl, endConn, httpOptions);
  }

  // postUserRating(rating): Observable<any> {
  //   let date = new Date()
  //   let deviceId = date.getTime() +"-"+ localStorage.getItem("sessionId")
  //   let body = {
  //     "botId": "3HS4KIT0NK",
  //     "deviceId": deviceId,
  //     "rating": rating,
  //     "sessionId": localStorage.getItem("sessionId")
  //   };
  //   const apiUrl = "https://w3k2y2lwpe.execute-api.us-west-2.amazonaws.com/chatbot-dev/rating";
  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       "Content-Type": "application/json",
  //     }),
  //   };
  //   return this.http.post<any>(apiUrl, body, httpOptions);
  // }
}
